import { render, staticRenderFns } from "./AnlingChaiLing.vue?vue&type=template&id=4c40fe4e&scoped=true&"
import script from "./AnlingChaiLing.vue?vue&type=script&lang=js&"
export * from "./AnlingChaiLing.vue?vue&type=script&lang=js&"
import style0 from "./AnlingChaiLing.vue?vue&type=style&index=0&id=4c40fe4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c40fe4e",
  null
  
)

export default component.exports